import { Application } from "@hotwired/stimulus";
import CartController from "../controllers/cart_controller";
import ClickableRowController from "../controllers/clickable_row_controller";
import ClipboardController from "../controllers/clipboard_controller";
import DropdownController from "../controllers/dropdown_controller";
import GivingEmbedSnippetController from "../controllers/giving_embed_snippet_controller";
import InputMaskController from "../controllers/input_mask_controller";
import LineItemController from "../controllers/line_item_controller";
import OverlayController from "../controllers/overlay_controller";
import PasswordToggleController from "../controllers/password_toggle_controller";
import RowLinkController from "../controllers/row_link_controller";

window.Stimulus = Application.start();
Stimulus.register("cart", CartController);
Stimulus.register("clickable-row", ClickableRowController);
Stimulus.register("clipboard", ClipboardController);
Stimulus.register("dropdown", DropdownController);
Stimulus.register("giving-embed-snippet", GivingEmbedSnippetController);
Stimulus.register("input-mask", InputMaskController);
Stimulus.register("line-item", LineItemController);
Stimulus.register("overlay", OverlayController);
Stimulus.register("password-toggle", PasswordToggleController);
Stimulus.register("row-link", RowLinkController);
